import {Component, forwardRef, Injector, Input} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {InventoryStockSizeSearchModel} from "../inventory-stock-size-search.model";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";

const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => InventoryStockSizeSingleSelectEditControlComponent),
    multi: true
};

@Component({
    selector: "wbo-inventory-stock-size-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [CUSTOM_VALUE_ACCESSOR,
        provideSearchModel(InventoryStockSizeSearchModel)
    ]
})
export class InventoryStockSizeSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<InventoryStockSizeSearchModel> {
    private _inventoryId: number;

    constructor(model: InventoryStockSizeSearchModel, injector: Injector) {
        super(model, injector, "id", "name");
    }

    get inventoryId(): number {
        return this._inventoryId;
    }

    @Input()
    set inventoryId(value: number) {
        this._inventoryId = value;

        if (this._inventoryId) {
            this.model.filter["inventoryId"] = value;
            this.model.search().subscribe(() => this.data = this.model.data);
        }
    }
}
